export default __webpack_public_path__ + "static/media/business-login.c4d7111e.svg";